import { lazy } from "react";

export { TIMESHEET_PATH } from "./path";
export const TimesheetPage = lazy(() => import("./page"));
